module.exports = __webpack_public_path__ + "img/title-bg.8df7c1db.png";